var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      staticClass: "historicoModal",
      attrs: {
        titulo: "Histórico",
        width: _vm.width,
        height: 700,
        bodyStyle: { height: "auto", padding: "0" }
      },
      on: { closeModal: _vm.closeModal }
    },
    [
      _c("template", { slot: "body" }, [
        _c(
          "div",
          { staticClass: "extra-margin-bottom" },
          [
            _c(
              "el-collapse",
              {
                model: {
                  value: _vm.abaAtiva,
                  callback: function($$v) {
                    _vm.abaAtiva = $$v
                  },
                  expression: "abaAtiva"
                }
              },
              _vm._l(_vm.arrayHistorico, function(historico) {
                return _c(
                  "el-collapse-item",
                  { key: historico.id },
                  [
                    historico.credenciado
                      ? _c(
                          "template",
                          { slot: "title" },
                          [
                            _c("el-col", { staticStyle: { float: "left" } }, [
                              _c(
                                "p",
                                {
                                  staticClass: "titleCollapse",
                                  staticStyle: { "text-align": "left" }
                                },
                                [_vm._v(_vm._s(historico.credenciado))]
                              )
                            ]),
                            _c("el-col", { staticStyle: { float: "right" } }, [
                              _c(
                                "p",
                                {
                                  staticClass: "titleCollapse",
                                  staticStyle: { "text-align": "right" }
                                },
                                [_vm._v(_vm._s(historico.data))]
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("p", [
                      _c("span", { staticClass: "bold" }, [_vm._v("Ação:")]),
                      _vm._v(" " + _vm._s(historico.acao.nome))
                    ]),
                    _c("p", [
                      _c("span", { staticClass: "bold" }, [
                        _vm._v("Responsável:")
                      ]),
                      _vm._v("  " + _vm._s(historico.responsavel))
                    ]),
                    _c("p", [
                      _c("span", { staticClass: "bold" }, [
                        _vm._v("Justificativa:")
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            historico.acao.codigo === "VINCULAR"
                              ? "Vinculação de credenciado de vistoria"
                              : historico.justificativa
                          )
                      )
                    ])
                  ],
                  2
                )
              }),
              1
            ),
            _vm.arrayHistorico.length === 0
              ? _c("div", [
                  _c(
                    "p",
                    {
                      staticClass: "bold",
                      staticStyle: { "font-size": "16px" }
                    },
                    [
                      _vm._v(
                        "Esse processo não possui histórico de vistoriador credenciado"
                      )
                    ]
                  )
                ])
              : _vm._e()
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06e094b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06e094b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/AppModalHistoricoVistoriadores.vue
// module id = null
// module chunks = 